import { TokenProvider } from "@revelate/types";
import { ArrowDownUpIcon } from "lucide-react";
import { format, formatDistance } from "date-fns";
import { getLastDealSyncTimeByCompanyAndProvider } from "@/lib/supabase";
import { useEffect, useState } from "react";

const today = new Date();

interface LastDealSyncStatusProps {
  providerId: TokenProvider;
}

export function LastDealSyncStatus({ providerId }: LastDealSyncStatusProps) {
  const [lastSyncTime, setLastSyncTime] = useState<Date | null>(null);

  async function fetchLastSyncTime() {
    const res = await getLastDealSyncTimeByCompanyAndProvider(3, providerId);
    if (!res) return;
    setLastSyncTime(new Date(res));
  }

  useEffect(() => {
    fetchLastSyncTime();
  }, [])

  if (!lastSyncTime) return null;

  return (
    <div className="flex flex-col gap-2 mt-6">
      <div className="flex flex-row space-x-2 items-start">
        <div className="w-4 h-4 mt-1 rounded-full flex justify-center items-center">
          <ArrowDownUpIcon className="text-paid-foreground h-3 w-3" strokeWidth="2" />
        </div>
        <div>
          <label
            htmlFor="syncstatus"
            className="text-sm font-medium text-gray-800 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Last synced {format(lastSyncTime, "PPp")}
          </label>
          <p className="text-xs text-gray-500">
            {formatDistance(lastSyncTime, today, { addSuffix: true })}
          </p>
        </div>
      </div>
    </div>
  );
}
